import styled from 'styled-components';

const StyledDashboard = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  grid-template-rows: repeat(12, 1fr);
`;

export default StyledDashboard;
